module.exports = __webpack_public_path__ + "static/Compliance.ai-3171f25526bd523583e7bb9f12f7d033.jpg";